import React from 'react';

export default props => (
  <div>
    { props.children }
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Root.js